import styled from 'styled-components'

export const headerSize = '1.4rem'
export const normalSize = '1rem'
export const smallSize = '0.9rem'
export const tinySize = '0.75rem'

export const ContactWrapper = styled.div`
  clear: both;
  width: 100%;
  color: ${({ theme }) => theme.colors.invert};
`

export const Header = styled.div`
  padding: calc(3 * ${normalSize}) 0px;
`
export const HeaderLineBold = styled.div`
  font-size: ${headerSize};
  font-weight: bold;
  margin: 0px ${normalSize};
  padding-top: ${normalSize};
`

export const HeaderLine = styled.div`
  font-size: ${headerSize};
  margin: 0px ${normalSize};
  padding-top: ${normalSize};
`

export const ColumnWrapper = styled.div`
  clear: both;
  display: flex;
  float: left;
  width: 100%;
  padding: 0px;
`

export const ContactColumn = styled.div`
  display: inline;
  padding: ${normalSize} 0;
  margin: 0px ${normalSize};
  width: calc(33% - 2 * ${normalSize});
  height: calc(36 * ${normalSize});
  border-bottom: 1px solid ${({ theme }) => theme.colors.invert};
  border-top: 1px solid ${({ theme }) => theme.colors.invert};
  overflow-x: hidden;
  overflow-y: auto;
`

export const ColumnBody = styled.div`
  font-size: ${normalSize};
  padding: ${normalSize} 0px;
  min-height: calc(4 * ${normalSize});
`

export const ColumnBlock = styled.div`
  padding-bottom: calc(2 * ${normalSize});
`

export const ColumnHeader = styled.h4`
  font-weight: bold;
  margin-bottom: 15px;
`

export const ButtonContainer = styled.div`
  padding: 2rem 2px;
`

export const NormalWeight = styled.span`
  font-weight: normal;
`

export const EmText = styled.em`
  font-size: ${normalSize};
  font-weight: 400;
  display: inline-block;
  margin-bottom: ${normalSize};
`

export const TinyText = styled.div`
  font-size: ${tinySize};
  font-weight: 100;
`

export const MailTo = styled.a`
  color: ${({ theme }) => theme.colors.invert};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const LinkImage = styled.img`
  cursor: pointer;
  &:hover {
    transform: scale(1.3, 1.3);
  }
`

export const ContactListWrapper = styled.div`
  display: flex;
  flex-direction: column;

  transition: opacity 0.5s;
  font-size: ${normalSize};
`

/* stylelint-disable block-no-empty */
export const ContactList = styled.ul``
/* stylelint-enable block-no-empty */

export const TitleList = styled.ul`
  margin-bottom: calc(2 * ${normalSize});
`

export const Contact = styled.li`
  display: flex;
  flex-direction: row;
  padding-bottom: ${normalSize};

  img {
    width: 180px;
    height: 120px;
    margin-right: 16px;
    object-fit: cover;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/contactStyles.ts